module.exports = __webpack_public_path__ + "img/frame3.e1c4d567.jpg";